import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import withStyles from '../../core/withStyles';
import { preventDefault } from '../../helpers';
import styles from './MenuDrawerItem.styles';
const isRenderFn = (value) => typeof value === 'function';
export const MenuDrawerItem = ({ label, active = false, href = '', target, onClick, classes, children, }) => {
    if (isRenderFn(children)) {
        return children({
            className: classes.root,
            activeClassName: classes.active,
        });
    }
    return (_jsx("a", Object.assign({ href: href, target: target, className: cn(classes.root, active && classes.active) }, (onClick ? { onClick: preventDefault(onClick) } : {}), { children: label })));
};
export default withStyles(styles)(MenuDrawerItem);
//# sourceMappingURL=MenuDrawerItem.js.map